import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HotelCategory } from '../../../components/HotelCategory/index.js';
import { LabelMediumBold, LabelSmall } from '../../../primitives/index.js';
import { qaId } from '../../../utils/index.js';
import { TRAVEL_DETAILS_OVERLAY_QA_ID } from '../../../utils/qaId.js';
export const Info = /*#__PURE__*/_styled(({
  rating,
  hotel,
  hotelCategoryType,
  country = '',
  region = '',
  city = ''
}) => {
  const location = [city, region, country].filter(Boolean).join(', ');
  return _jsxs("div", {
    children: [_jsx(HotelCategory, {
      type: hotelCategoryType,
      value: rating,
      withTooltip: true,
      "data-testid": qaId(TRAVEL_DETAILS_OVERLAY_QA_ID, 'hotel', 'category')
    }), _jsx(LabelMediumBold, {
      "data-testid": qaId(TRAVEL_DETAILS_OVERLAY_QA_ID, 'hotel', 'name'),
      children: hotel
    }), location && _jsx(LabelSmall, {
      color: "contentSecondary",
      "data-testid": qaId(TRAVEL_DETAILS_OVERLAY_QA_ID, 'hotel', 'region'),
      children: location
    })]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "ec7xf1w0"
} : {
  target: "ec7xf1w0",
  label: "Info"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm8uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU0ciLCJmaWxlIjoiSW5mby5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBIb3RlbENhdGVnb3J5IH0gZnJvbSAnLi4vLi4vLi4vY29tcG9uZW50cy9Ib3RlbENhdGVnb3J5L2luZGV4LmpzJztcbmltcG9ydCB7IExhYmVsTWVkaXVtQm9sZCwgTGFiZWxTbWFsbCB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvaW5kZXguanMnO1xuaW1wb3J0IHsgcWFJZCB9IGZyb20gJy4uLy4uLy4uL3V0aWxzL2luZGV4LmpzJztcbmltcG9ydCB7IFRSQVZFTF9ERVRBSUxTX09WRVJMQVlfUUFfSUQgfSBmcm9tICcuLi8uLi8uLi91dGlscy9xYUlkLmpzJztcbmV4cG9ydCBjb25zdCBJbmZvID0gc3R5bGVkKCh7IHJhdGluZywgaG90ZWwsIGhvdGVsQ2F0ZWdvcnlUeXBlLCBjb3VudHJ5ID0gJycsIHJlZ2lvbiA9ICcnLCBjaXR5ID0gJycsIH0pID0+IHtcbiAgICBjb25zdCBsb2NhdGlvbiA9IFtjaXR5LCByZWdpb24sIGNvdW50cnldLmZpbHRlcihCb29sZWFuKS5qb2luKCcsICcpO1xuICAgIHJldHVybiAoX2pzeHMoXCJkaXZcIiwgeyBjaGlsZHJlbjogW19qc3goSG90ZWxDYXRlZ29yeSwgeyB0eXBlOiBob3RlbENhdGVnb3J5VHlwZSwgdmFsdWU6IHJhdGluZywgd2l0aFRvb2x0aXA6IHRydWUsIFwiZGF0YS10ZXN0aWRcIjogcWFJZChUUkFWRUxfREVUQUlMU19PVkVSTEFZX1FBX0lELCAnaG90ZWwnLCAnY2F0ZWdvcnknKSB9KSwgX2pzeChMYWJlbE1lZGl1bUJvbGQsIHsgXCJkYXRhLXRlc3RpZFwiOiBxYUlkKFRSQVZFTF9ERVRBSUxTX09WRVJMQVlfUUFfSUQsICdob3RlbCcsICduYW1lJyksIGNoaWxkcmVuOiBob3RlbCB9KSwgbG9jYXRpb24gJiYgKF9qc3goTGFiZWxTbWFsbCwgeyBjb2xvcjogXCJjb250ZW50U2Vjb25kYXJ5XCIsIFwiZGF0YS10ZXN0aWRcIjogcWFJZChUUkFWRUxfREVUQUlMU19PVkVSTEFZX1FBX0lELCAnaG90ZWwnLCAncmVnaW9uJyksIGNoaWxkcmVuOiBsb2NhdGlvbiB9KSldIH0pKTtcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SW5mby5qcy5tYXAiXX0= */");